/* globals Class, $H, Ajax, CodeMirror */
var jQuery   = require('jquery');
var ubBanzai = require('ub/control/banzai-features');

window.jui.CodeEditor = Class.create(window.jui.Component, window.jui.ControlModel, {
  options: function($super, options) {
    return $super($H({
      onMouseup: function(){},
      onKeyup: function(){},
      onChange: function(){},
      toggleCheckboxYPosition: '1px',
      attributes: {
        className: 'jui-code-editor'
      }
    }).merge(options));

  },

  initialize: function($super, options) {
    $super( options );
  },

  installUI: function($super) {
    $super();
    var $labelContainer = jQuery('<div class="label-container">');
    this.insert($labelContainer[0]);

    this.label = jQuery('<div class="code-label">' + this.options.label + '</div>')[0];
    $labelContainer.append(this.label);

    this.input = this.insert(new Element('textarea'));
    this.errors = [];
    this.isValidContent = true;

    var self = this;

    this.codeMirror = CodeMirror( function(elt) {
      elt.observe( 'mouseup', self.options.onMouseup );
      elt.observe( 'keyup', self.options.onKeyup );
      self.e.replaceChild( elt, self.input );
    }, {
      mode: self.options.mode || 'text/html',
      tabMode: self.options.tabMode || 'indent',
      lineNumbers: self.options.lineNumbers ? self.options.lineNumbers : true,
      lineWrapping: self.options.lineWrapping ? self.options.lineWrapping : true,
      gutter: self.options.gutter ? self.options.gutter : true,
      theme: 'yeti',
      onChange: self.options.onChange
    } );

    this.toggleWrapping = new window.jui.FormCheckboxInput({
      label: "Soft Wrap",
      checked: self.options.lineWrapping ? self.options.lineWrapping : true,
      inputId: 'toggle-wrapping-checkbox',
      onclick: function( e ) {
        var wrap = e.source.getValue();
        self.codeMirror.setOption( 'lineWrapping', wrap );
      }
    });

    $labelContainer.append(this.toggleWrapping.e);
    $labelContainer.append(this.label.e);
  },

  focus: function() {
    this.codeMirror.focus();
  },

  setValue: function(value) {
    this.codeMirror.setValue(value);
    this.codeMirror.refresh();
  },

  getValue: function() {
    return this.codeMirror.getValue();
  },

  isValid: function() {
    return !!this.isValidContent;
  },

  setIsValid: function(isValid) {
    this.isValidContent = isValid;
  },

  getErrors: function() {
    return this.errors;
  },

  showHTMLWarningIfInvalid: function(model, doneFunction, isValidContent){
    //severity is always set to warning until we get errors back from the publisher;
    isValidContent = isValidContent || this.getSeverityLevel() !== 'Error';
    if(isValidContent) {
      model.updateButton('done', 'Save Code', doneFunction.bind(model, isValidContent));
      model.hideWarningDialog();
    } else {
      model.showWarningDialog('This code appears to be invalid, which might result in a broken published page.');
      model.updateButton('done', 'Save Anyway', doneFunction.bind(model, true));
    }
  },

  isNotEmpty: function(text) {
    return text.strip().length > 0;
  },

  getSeverityLevel: function() {
    //For now always return Warning.  Once we get errors from
    //the publisher we can return different severity levels such as error.
    return 'Warning';
  },

  isValidContentHTML: function(model, doneFunction) {
    var self = this;
    var hasContent = this.isNotEmpty(this.getValue());
    var isSandboxMode = ubBanzai.features.isSandboxEnabled();

    if (hasContent && !isSandboxMode) {
      var close = false;
      return new Ajax.Request('/validator/html', {
        method: 'post',
        parameters: {html: this.getValue()},
        asynchronous: true,
        onLoading: function() {
          model.showWaiter('Validating');
          model.hideWarningDialog();
        },
        onLoaded: function() {
          model.hideWaiter();
        },
        onSuccess: function(transport) {
          var json = transport.responseJSON;
          var severity = self.getSeverityLevel();
          if(severity !== 'Error' || (!self.isValid() && !json.valid)){close = true;}
          self.isValidContent = json.valid;
          self.errors  = json.errors;
          if(close) {
            doneFunction.call(model, true);
          }
          else if(self.isValidContent) {
            doneFunction.call(model, true);
          } else {
            self.showHTMLWarningIfInvalid(model, doneFunction, false);
          }
        },
        onFailure: function() {
          //If we do not get a resonse from the server call the doneFunction
          //any way so not to ruin user experiance if we cannot validate.
          doneFunction.call(model, true);
        }
      });
    } else {
      this.isValidContent = true;
      this.errors = [];
      doneFunction.call(model, true);
    }
  }

});



//////////////////
// WEBPACK FOOTER
// ./src/legacy/jui/code_editor.js
// module id = 306
// module chunks = 0 1